import { motion } from "framer-motion";

/** Line-mask reveal used in the hero — pass lines as string[] */
export function RevealLines({ lines, delay = 0, className = "", stagger = 0.12 }) {
  return (
    <>
      {lines.map((ln, i) => (
        <span key={i} className={`line-mask ${className}`}>
          <motion.span
            className="inline-block"
            initial={false}
            animate={{ y: "0%" }}
            transition={{ delay: delay + i * stagger, duration: 1.05, ease: [0.76, 0, 0.24, 1] }}
          >
            {ln}
          </motion.span>
        </span>
      ))}
    </>
  );
}

export function Reveal({ children, delay = 0, y = 30, className = "" }) {
  return (
    <motion.div
      initial={false}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ delay, duration: 0.75, ease: [0.76, 0, 0.24, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
